/**
 * Admin Product Management — `/admin/products`
 *
 * Every team's products in one table with hero thumbnails, search, edit and soft-delete.
 * Backed by the `adminProducts` tRPC router (1:1 panel↔router parity per `kit-vidmax-admin`).
 *
 * @feature-spec brain/vidmax/feature-specs/admin-products.md
 */
import { createFileRoute } from "@tanstack/react-router"
import type { ReactElement } from "react"

import { AdminProductList } from "~/components/Admin/AdminProductList"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

function AdminProducts(): ReactElement {
  return (
    <>
      <CustomHead title="All Products" />
      <div>
        <AdminProductList />
      </div>
    </>
  )
}

function AdminProductsWrapper(): ReactElement {
  return (
    <SuperAdminLayout>
      <AdminProducts />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/products")({
  component: AdminProductsWrapper,
})
